export default {
  COMMENT: 'comment',
  HISTORY: 'history',
}
